import axios from 'axios'

const PlanService = {
  add: (data) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/plan/add`, data, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(({ data }) => {
        return data
      })
      .catch(err => { throw err })
  },
  update: (data) => {
    return axios.patch(`${process.env.REACT_APP_API_URL}/plan/update`, data, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(({ data }) => {
        return data
      })
      .catch(err => { throw err })
  },
  delete: (data) => {
    return axios.delete(`${process.env.REACT_APP_API_URL}/plan/delete?plan_id=${data}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(({ data }) => {
        return data
      })
      .catch(err => { throw err })
  },
  list: () => {
    return axios.get(`${process.env.REACT_APP_API_URL}/plan/`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(({ data }) => {
        return data
      })
      .catch(err => { throw err })
  },
  detail: (data) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/plan/detail?plan_id=${data}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(({ data }) => {
        return data
      })
      .catch(err => { throw err })
  }
}

export default PlanService